export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="mb-4">
              <span className="text-purple-600 text-sm font-semibold tracking-widest uppercase">
                ABOUT US
              </span>
            </div>
            
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight font-serif">
              Building Trust Through Technology
            </h2>
            
            <div className="w-20 h-1 bg-purple-600 mb-8"></div>
          </div>

          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              OPEN STUDIO d.o.o. is a leading technology company dedicated to protecting your digital privacy. We specialize in developing cutting-edge VPN solutions that ensure your online activities remain secure and anonymous.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              Our mission is to provide enterprise-grade security accessible to everyone. With advanced encryption protocols and a strict no-logs policy, we guarantee that your data stays private and your identity protected at all times.
            </p>

            <div className="bg-gray-50 rounded-2xl p-8 mt-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-6">Contact Information</h3>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-600 text-sm mb-1">Email</p>
                    <a href="mailto:information@openstudiodoo.com" className="text-gray-900 font-medium hover:text-purple-600 transition-colors cursor-pointer">
                      information@openstudiodoo.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-line text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-600 text-sm mb-1">Phone</p>
                    <a href="tel:+12137533391" className="text-gray-900 font-medium hover:text-purple-600 transition-colors cursor-pointer">
                      +1 213 753 3391
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-map-pin-line text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-gray-600 text-sm mb-1">Address</p>
                    <p className="text-gray-900 font-medium">
                      Put Vrela 74c<br />
                      23000 Zadar, Croatia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
